import { Component, ChangeDetectionStrategy } from '@angular/core';

import { DynamicDialogRef } from '@shared/components/ui/dynamic-dialog/dynamic-dialog-ref';
import { DynamicDialogConfig } from '@shared/components/ui/dynamic-dialog/dynamic-dialog.component';
import { ButtonComponent } from '@shared/components/ui/button/button.component';
import { ConfirmDialogData } from '../../services/dialog.service';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonComponent
  ],
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {
  data: ConfirmDialogData;

  constructor(
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    this.data = config.data as ConfirmDialogData;
  }

  getIconClass(): string {
    switch (this.data.type) {
      case 'success':
        return 'text-green-500 text-3xl';
      case 'warning':
        return 'text-orange-500 text-3xl';
      case 'error':
        return 'text-red-500 text-3xl';
      case 'info':
      default:
        return 'text-blue-500 text-3xl';
    }
  }

  getButtonVariant(): 'primary' | 'secondary' | 'destructive' {
    switch (this.data.type) {
      case 'error':
        return 'destructive';
      case 'warning':
        return 'destructive';
      case 'success':
        return 'primary';
      case 'info':
      default:
        return 'primary';
    }
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
